(() => {
  'use strict';
  const dialog = document.getElementById('fd-restock-dialog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const config = JSON.parse(document.getElementById('fd-restock-config').textContent);
  const form = dialog.querySelector('form');
  const input = form.querySelector('input');
  const submit = form.querySelector('button[type="submit"]');
  const fields = form.querySelector('[data-restock-fields]');
  const status = form.querySelector('[data-restock-status]');
  const error = form.querySelector('[data-restock-error]');
  let variantId = '';
  let pending = false;
  let opener = null;
  document.body.appendChild(dialog);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fd-restock]');
    if (!trigger || pending) return;
    const card = trigger.closest('[data-variant-id]');
    if (!card || !/^\d+$/.test(card.dataset.variantId) || card.dataset.available !== 'false') return;
    event.preventDefault();
    variantId = card.dataset.variantId;
    opener = trigger;
    form.reset();
    fields.hidden = false;
    status.hidden = true;
    error.hidden = true;
    dialog.querySelector('#fd-restock-color').textContent = [card.dataset.modelCode, card.dataset.name].filter(Boolean).join(' · ');
    dialog.showModal();
    input.focus();
  });
  dialog.querySelector('[data-restock-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { if (opener) opener.focus({preventScroll:true}); });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || !form.reportValidity() || !/^\d+$/.test(variantId)) return;
    pending = true;
    submit.disabled = true;
    submit.textContent = config.saving;
    error.hidden = true;
    form.setAttribute('aria-busy','true');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(config.companyId), {
        method:'POST',
        headers:{'Content-Type':'application/vnd.api+json',revision:'2026-07-15'},
        signal:controller.signal,
        body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email:input.value.trim()}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::' + variantId}}}}})
      });
      if (response.status !== 202) throw new Error('Restock signup not accepted');
      input.value = '';
      fields.hidden = true;
      status.textContent = config.success;
      status.hidden = false;
    } catch (_) {
      error.textContent = config.error;
      error.hidden = false;
    } finally {
      clearTimeout(timeout);
      pending = false;
      submit.disabled = false;
      submit.textContent = config.submit;
      form.setAttribute('aria-busy','false');
    }
  });
})();
